import { Injectable, Signal, computed, inject } from '@angular/core';
import { PermissionService } from '../permission.service';
import { PermissionCode, RoleProfile } from '../permission.types';
import { ApiSessionService } from './api-session.service';

@Injectable()
export class ApiPermissionService extends PermissionService {
  private readonly session = inject(ApiSessionService);
  readonly currentProfile: Signal<RoleProfile> = computed(() => this.session.roleProfile());
  hasRight(code: PermissionCode): boolean { return this.session.permissions().includes(code); }
}
